import React from 'react';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  TextField,
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import styled from 'styled-components';

const ActivityItem = ({
  data: activity,
  index,
  onChange,
  onChecked,
  onDelete,
}) => {
  return (
    <ActivityContainer>
      <InputText
        name={'name'}
        label={'Ingrese una actividad ejecutada *'}
        value={activity.name}
        size='small'
        variant='outlined'
        onChange={(e) => onChange(e, index, 'executedActivities')}
        placeholder='Ejem: Se elaboró la planificación de actividades.'
      />
      <CheckBoxesContainer>
        <FormControl component='fieldset'>
          {/* <FormLabel component='legend'>Semanas</FormLabel> */}
          <FormGroup aria-label='position' row>
            <FormControlLabel
              value='top'
              control={
                <Checkbox
                  color='primary'
                  checked={activity.week[0]}
                  name='0'
                  onChange={(e) => onChecked(e, index)}
                />
              }
              label='S1'
              labelPlacement='top'
            />
            <FormControlLabel
              value='top'
              control={
                <Checkbox
                  color='primary'
                  checked={activity.week[1]}
                  name='1'
                  onChange={(e) => onChecked(e, index)}
                />
              }
              label='S2'
              labelPlacement='top'
            />
            <FormControlLabel
              value='top'
              control={
                <Checkbox
                  color='primary'
                  checked={activity.week[2]}
                  name='2'
                  onChange={(e) => onChecked(e, index)}
                />
              }
              label='S3'
              labelPlacement='top'
            />
            <FormControlLabel
              value='top'
              control={
                <Checkbox
                  color='primary'
                  checked={activity.week[3]}
                  name='3'
                  onChange={(e) => onChecked(e, index)}
                />
              }
              label='S4'
              labelPlacement='top'
            />
          </FormGroup>
        </FormControl>
      </CheckBoxesContainer>
      {index > 0 ? (
        <DeleteButton
          onClick={() => onDelete(index, 'executedActivities')}
          color='primary'
        />
      ) : (
        <Space></Space>
      )}
    </ActivityContainer>
  );
};

const ActivityContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
`;

const CheckBoxesContainer = styled.div`
  display: flex;
  width: 40%;
  justify-content: center;
  margin: 0;
  padding: 0;
`;

const DeleteButton = styled(DeleteIcon)`
  cursor: pointer;
`;

const InputText = styled(TextField)`
  justify-self: flex-start;
  width: 80%;
`;

const Space = styled.span`
  width: 2em;
`;

export default ActivityItem;
